export default function fullscreenSearch() {
    const openBtn = document.getElementById('open-search');
    const overlay = document.getElementById('searchOverlay');
    const searchBox = document.getElementById('searchBox');
    const input = searchBox.querySelector('input');

    function openSearch() {
    overlay.classList.remove('hidden');
    input.focus();
    }

    function closeSearch() {
    overlay.classList.add('hidden');
    input.value = '';
    }

    openBtn.addEventListener('click', openSearch);

    // Click outside input
    overlay.addEventListener('click', (e) => {
    if (!searchBox.contains(e.target)) {
        closeSearch();
    }
    });

    // Press ESC key
    document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        closeSearch();
    }
    });
}